import * as React from 'react';
import * as ReactDom from 'react-dom';

import { useContext, useReducer, useState, useEffect } from "react";
import { MessagesContext } from "../common/context";


import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';

import { escape, fromPairs } from '@microsoft/sp-lodash-subset';
import * as Fabric from 'office-ui-fabric-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import  * as uuidv4 from "uuid/v4";
import { Message } from './Message';

import { getAuthenticatedClient } from "../../auth/authClient";
var graph = require('@microsoft/microsoft-graph-client');

/**
 * 
 * @param param0 props params is assigned to variables
 * {
 * @param teamId 
 * @param channelId 
 * @param context 
 * }
 */
export  function MessagesContainer({teamId, channelId, accessToken, pageNumber}) {

    const [messagesList, setMessagesList] = useState();
    const { dispatch, state } = useContext(MessagesContext);
    const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();
    
    log.info(`@MessagessContainer`);
    log.debug(`@MessagessContainer accessToken: ${accessToken}`);

      React.useEffect(() => {    
        log.info(`useEffect @ MessagessContainer`);
            getMessages(teamId, channelId, accessToken,pageNumber).then((msg) =>{
          });        
      }, []);
  
    
/**
 * const getMessages
 * Gets the mesages based on @microsoft/sp-http client
 * @param teamId 
 * @param channelId 
 * @param accessToken
 */
    const getMessages = async (teamId, channelId, accessToken, pageNumber) =>{
      log.info(`getMessages @ MessagessContainer`);
  
       const _top = state.numberOfItemsInPage;
       const _skip = _top*(pageNumber-1); 
       //const _order = `lastModifiedDateTime DESC`; 
        //const oDataQuery = `?$top=3&$skip=2`;
       const oDataQuery = `?$top=${_top}&$skip=${_skip}`;//&$orderby=${_order}`;
       const messagesUrl = `/teams/${teamId}/channels/${channelId}/messages${oDataQuery}`; //MESSAGES_URL;
       const client = getAuthenticatedClient(accessToken);

       try {
        const res = await client
                .api(messagesUrl)
                .headers({
                  "Content-Type" : "application/json;charset=UTF-8",
                   "mode": "cors",
                  "Access-Control-Allow-Origin" : '' 
                })
                .version('beta')
                .get((error, messages, rawResponse) => {
    
                  //console.log('@getMessages >  selectedMessages ' + JSON.stringify(messages)); 
                    
                    if (messages) {
                                          
                      let someMessages =    messages.value.filter(message =>{                         
                        if (message.body.content.length > 0 ) return true;
                        return false;
                      });
    
                      const  selectedMessages =   someMessages.map(message => {
                          const _message = 
                          {
                              id :  message.id,
                              date: message.createdDateTime ? message.createdDateTime : `not availabe`,
                              text :  `[Message:] ${message.body.content}`,
                              webUrl : message.webUrl,
                              user : message.from.user.displayName,
                              type : "Message",
                              selected : false
                          };
                      return _message;
                      });
                    //console.log('@getMessages >  selectedMessages ' + JSON.stringify(selectedMessages));
                    const selectedMessagesReversed = [...selectedMessages];//.reverse()  
                    setMessagesList(selectedMessagesReversed); 
                    return selectedMessagesReversed;
    
                    } else {
                        return [];
                    }
                  }
                );         
       } catch (error) {
         log.error(`getMessages @ MessagessContainer error: ${JSON.stringify(error)}`);
      } finally {
        log.info(`finally / getMessages @ MessagessContainer`);
      }
     
    }
      
    const MyErrorComponent = ({error})=>{  
        log.error(`renderMessages @ MessagessContainer error ${error.message}`);
      return (
          <div >Error. Search in Logs for details.</div>
      )
    }

    const renderMessages = ()=>{

      if (messagesList == null || messagesList == undefined ){
        return (
          <>  
          <Spinner size={SpinnerSize.large} />
          </> 
        )
      }
  
      const _messagesList = messagesList.map(message => (
        <ErrorBoundary  key={uuidv4()}
              render={() => 
                          <Message    
                                  
                                  teamID = {teamId}
                                  channelId = {channelId}
                                  messageId = {message.id}
                                  message = {message}
                                  accessToken = {accessToken}
                                  ></Message>
              }
              renderError={({ error, errorInfo }) => <MyErrorComponent error={error} />}
        >
        </ErrorBoundary>              
        )
      )
      return _messagesList;
    }

    return (
    <>
      {renderMessages()}
    </>
    )
  }
  
        // context.msGraphClientFactory
        // .getClient()
        // .then((client)=> {
        //         client

  // <li key={create_UUID()}>
//               <a href={message.webUrl}>{message.content.substr(0,50)} </a>
//             </li>


//    const context = this.props.context;
//const graphClient = await context.msGraphClientFactory.getClient();
//const appsResponse = await graphClient.api('appCatalogs/teamsApps').version('v1.0').get();
//const _context = this.context;

  //-------------------------

// const getMessagesMe = async (teamId, channelId, context) =>{
//     console.log(`@getMessages >  teamId - ${teamId} , channelId - ${channelId}`);
//     context.msGraphClientFactory
//     .getClient()
//     .then((client: MSGraphClient)=> {
//             client
//             .api('/me')
//             .get((error, user, rawResponse) => {
//                 console.log('@getMessages >  user ' + JSON.stringify(user));
//                 return [{}];
//                 }
//             );
  
//                         //console.log('msGraphClient: ' + JSON.stringify(msGraphClient))  
                                
                                
//                                 // const _me =  await msGraphClient.api('/me').get();
//                                 // const _meValue = _me.value
//                                 // console.log ('me: ' + JSON.stringify(_me));
//                                 // return _meValue; //_messages;
//             }
//     )};


// //------------------------



    // const _top = state.numberOfItemsInPage;
      // const _skip = _top*(pageNumber); 
      // const _order = `displayName DESC` 
      //  //const oDataQuery = `?$top=3&$skip=2`;
      //  const oDataQuery = `?$top=${_top}&$skip=${_skip}&$orderby=${_order}`;
            //  /teams/cb03b4f2-09b8-4a16-876a-ccd7a7780e3f/channels/${channelId}/messages${oDataQuery}`; //MESSAGES_URL;
      //https://graph.microsoft.com/v1.0/teams/cb03b4f2-09b8-4a16-876a-ccd7a7780e3f/channels/19:6590091dfb7a4f4a9040a02baf78aed5@thread.tacv2/messages
      //https://graph.microsoft.com/beta/teams/cb03b4f2-09b8-4a16-876a-ccd7a7780e3f/channels/19:6590091dfb7a4f4a9040a02baf78aed5@thread.tacv2/messages // ok
      //https://graph.microsoft.com/beta/teams/cb03b4f2-09b8-4a16-876a-ccd7a7780e3f/channels/19:6590091dfb7a4f4a9040a02baf78aed5@thread.tacv2/messages?$orderby=lastModifiedDateTime desc


    // {
    //   "error": {
    //     "code": "",
    //     "message": "The query specified in the URI is not valid. Query option 'OrderBy' is not allowed. To allow it, set the 'AllowedQueryOptions' property on EnableQueryAttribute or QueryValidationSettings.",
    //     "innerError": {
    //       "message": "Query option 'OrderBy' is not allowed. To allow it, set the 'AllowedQueryOptions' property on EnableQueryAttribute or QueryValidationSettings.",
    //       "request-id": "39c23f1a-fa3c-463e-a80e-64e3e7d192dc",
    //       "date": "2020-05-31T17:22:42"
    //     }
    //   }
    // }